/**
 * Decides whether the conversation screen should send POST /chat/mark-read
 * right now, and what the caller's "already sent" marker becomes.
 *
 * Returning nextLastSent alongside doSend is deliberate: the call site writes
 * the marker BEFORE it fires the mutation, so a slow response can never let a
 * second poll tick fire a duplicate call for the same message.
 */
export type typeMarkReadSent = {
  chatId: string;
  newestMessageId: string;
} | null;

export function resolveMarkReadStep(input: {
  chatId: string;
  isFocused: boolean;
  newestMessageId: string | null;
  lastSent: typeMarkReadSent;
}): { doSend: boolean; nextLastSent: typeMarkReadSent } {
  if (input.chatId === "") {
    return { doSend: false, nextLastSent: input.lastSent };
  }

  if (!input.isFocused) {
    return { doSend: false, nextLastSent: input.lastSent };
  }

  if (input.newestMessageId === null || input.newestMessageId === "") {
    return { doSend: false, nextLastSent: input.lastSent };
  }

  if (
    input.lastSent !== null &&
    input.lastSent.chatId === input.chatId &&
    input.lastSent.newestMessageId === input.newestMessageId
  ) {
    return { doSend: false, nextLastSent: input.lastSent };
  }

  return {
    doSend: true,
    nextLastSent: {
      chatId: input.chatId,
      newestMessageId: input.newestMessageId,
    },
  };
}
